// Computes the auto-incremented question number for a field at `index` within
// `fields`, counting only fields that are not hidden (`hide_alt`) so hidden
// questions don't create gaps or shift numbers for questions rendered after them.
export const getVisibleQuestionNumber = (fields, index) => {
  let count = 0;
  for (let i = 0; i <= index && i < (fields?.length ?? 0); i++) {
    if (!fields[i]?.hide_alt) count++;
  }
  return count;
};
